import { Button } from "@/components/ui/button";
import { MenuInfoBlockType } from "@/types/menu";

interface InfoBlockProps {
  item: MenuInfoBlockType;
}

export const InfoBlock = ({ item }: InfoBlockProps) => {
  if (!item) return null;

  return (
    <div className="relative flex flex-col gap-y-1">
      <span className="block h-[2px] w-6 rounded mb-6 bg-brand"></span>
      {item?.title && (
        <h5>{item?.title}</h5>
      )}
      {item?.subtitle && (
        <span className="paragraph-base">{item?.subtitle}</span>
      )}
      {item?.hasButton && item?.buttonText && (
        <div>
          <Button asChild variant={item?.buttonStyle} size="sm" className="mt-4">
            <a href={item?.link} className="inline-flex">
              {item?.buttonText}
              {/* <span className="material-symbols-outlined w-4.5 h-4.5" style={{ fontSize: '18px' }}>
                arrow_forward
              </span> */}
            </a>
          </Button>
        </div>
      )}
    </div>
  );
};

InfoBlock.displayName = 'NavInfoBlock'; 